

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action, State } from "vuex-class";
import userService from '@/service/userService'
import { AppUtil } from '@/utils/app.util'
import { CookieService, LocalStorageService, SessionStorageService } from "@/service/storageService";
import { Constants } from '@/const/Constants'
@Component
export default class HeaderNav extends Vue {
  private theme: string = "dark";
  private name: string | null | undefined = "";
  private showOperation: boolean = false;
  private created() {
    this.name = this.$route.name;
    const userInfo = userService.getLoginedUser()
    if (AppUtil.isNotEmpty(userInfo)) {
      this.setUserInfo(userInfo)
    }
  }
  @Watch("$route", { deep: true })
  private routechange(to: any, from: any) {
    this.name = to.name;
  }

  @Action('SET_SHOW_ACCOUNT_DIALOG_ASYN') handleAccountDialog!: (data: boolean) => void
  @Action('SET_ACCOUNT_DIALOG_TYPE_ASYN') changeAccountType!: (data: string) => void
  @Action('SET_USER_INFO_ASYN') setUserInfo!: (data: any) => void
  @State("userInfo") userInfo!: any;

  openAccountDialog(type: number) {
    if (type == 1) {
      this.handleAccountDialog(true)
      this.changeAccountType('login')
      return
    }
    if (type == 2) {
      this.handleAccountDialog(true)
      this.changeAccountType('register')
      return
    }
    if (type == 3) {
      this.handleAccountDialog(true)
      this.changeAccountType('setPasswd')
      return
    }
  }
  changeOperation() {
    this.showOperation = !this.showOperation
  }
  // 退出登录
  loginOut() {
    userService.loginOut().then((res: any) => {
      if (res && res.success) {
        userService.initVisitorsToken(userService.appInfoAtiak).then((data: any) => {
          if (data && data.success) {
            LocalStorageService.remove(Constants.Storage_Local.Login_Time);
            userService.removeCookieUser();
            SessionStorageService.remove(Constants.Storage_Session.Ext_Prompt_Flag);
            CookieService.remove(Constants.Cookie.Auth_Info, { path: '/', domain: '.chineseall.cn' });
          } else {
          }
        });
      } else {
        this.$Message.error("退出登录失败!");
      }
      this.setUserInfo(null)
      userService.removeCookieUser()
      this.$Message.success('退出登录成功')
    }).catch((err: any) => {
      this.$Message.error(err.msg || '退出登录失败')
    })
  }

  openAddNews(){
    if(this.userInfo && this.userInfo.nick){
      this.$router.push({ name: 'addnews' })
    }else{
      this.$Message.error('请先登录')
    }
  }


}
